var _excluded = ["children", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { j as m } from "./index.es33.js";
import { clsx as a } from "./index.es105.js";
import { Typography as f } from "./index.es35.js";
import "./index.es36.js";
import { Paginator as c } from "./index.es151.js";
import { Info as l } from "./index.es152.js";
import { StepChanger as x } from "./index.es153.js";
import { DEFAULT_PER_PAGE as d } from "./index.es154.js";
import { stylesColumns as j } from "./index.es155.js";
import p from "./index.es156.js";

var i = function i(_ref) {
  var o = _ref.total,
      s = _ref.page,
      _ref$perPage = _ref.perPage,
      r = _ref$perPage === void 0 ? d : _ref$perPage,
      t = _ref.left,
      n = _ref.right,
      e = _ref.onPageClick;
  return m.jsxs("div", {
    className: a(p.container, j(!!t, !!n)),
    children: [t, m.jsx("div", {
      children: r < o && m.jsx(c, {
        onPageClick: e,
        perPage: r,
        total: o,
        page: s
      })
    }), n]
  });
};

i.StepChanger = x;
i.Info = l;

i.NoRecords = function (_ref2) {
  var o = _ref2.children,
      s = _ref2.className,
      r = _objectWithoutProperties(_ref2, _excluded);

  return m.jsx(f.Body2, _objectSpread(_objectSpread({}, r), {}, {
    className: a(p.noRecords, s),
    children: o
  }));
};

export { i as Paginator };